// Skeleton de tabla: mantiene el header real de antd Table y reemplaza
// el contenido de cada celda por bloques "pulse", igual que en el Dashboard.

export const Sk = ({ w = '100%', h = 14, r = 8, style = {} }) => (
  <div style={{
    width: w, height: h, borderRadius: r,
    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    animation: 'skPulse 1.4s ease-in-out infinite',
    flexShrink: 0,
    ...style,
  }} />
);

export const SkStyleTag = () => (
  <style>{`
    @keyframes skPulse {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `}</style>
);

// Celda "item": avatar/ícono opcional + 1 o 2 líneas de texto, como las
// filas de "Productos más vendidos" / "Pedidos recientes" del Dashboard.
export const SkCell = ({ avatar, lines = 1, w1 = '70%', w2 = '40%' }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    {avatar && <Sk w={32} h={32} r={8} />}
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
      <Sk w={w1} h={12} />
      {lines === 2 && <Sk w={w2} h={10} />}
    </div>
  </div>
);

// Toma las columnas reales de una antd <Table> y devuelve una versión
// donde cada `render` muestra un SkCell en vez del valor real, preservando
// título, ancho y alineación del header tal cual.
export const skeletonColumns = (columns, opts = {}) =>
  columns.map((col, i) => ({
    ...col,
    render: () => (
      <SkCell
        avatar={opts.avatarIndex === i}
        lines={opts.twoLineIndexes?.includes(i) ? 2 : 1}
        w1={opts.widths?.[i]?.[0]}
        w2={opts.widths?.[i]?.[1]}
      />
    ),
  }));

export const skeletonRows = (n = 8) =>
  Array.from({ length: n }, (_, i) => ({ key: `sk-${i}` }));
